import { render, staticRenderFns } from "./HeroKitty.vue?vue&type=template&id=53113e7c&scoped=true&"
import script from "./HeroKitty.vue?vue&type=script&lang=js&"
export * from "./HeroKitty.vue?vue&type=script&lang=js&"
import style0 from "./HeroKitty.vue?vue&type=style&index=0&id=53113e7c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53113e7c",
  null
  
)

export default component.exports